<template>
  <div class="col-md-12">
    <div class="row">
      <div class="portlet light">
        <div class="portlet-title">
          <div class="caption caption-md">
            <i class="icon-globe theme-font hide"></i>
            <span class="caption-subject bold uppercase">Account directory</span>
          </div>
        </div>
        <div class="portlet-body">
          <form role="form" class="form-horizontal" @submit.prevent="">
            <div class="form-body">
              <div class="form-group form-md-line-input has-warning">
                <div class="col-md-12">
                  <div class="input-group">
                    <div class="input-group-control input-icon">
                      <i class="fa fa-search"></i>
                      <input type="text" placeholder="Type to search..." class="form-control" v-model="search">
                      <div class="form-control-focus"></div>
                    </div>
                    <span class="input-group-btn btn-right">
                        <button type="submit" data-style="expand-left"
                                class="btn green mt-ladda-btn ladda-button search-ad-submit"
                                @click.prevent="searchButton()">
                          <span class="ladda-label">Search</span>
                        </button>
                      </span>
                  </div>
                </div>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="accountsList.accounts"
                :pagination-options="{enabled: true}"
                v-if="accountsList.accounts.length"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'organizationName'">
                    <router-link :to="{ name: 'Manage Account Edit CaseMGR', params: { casemgrid: props.row.id } }" tag="a" class="" data-dismiss="modal" aria-hidden="true">
                      {{ props.row.organizationName }}
                    </router-link>
                  </span>
                  <span v-else-if="props.column.field === 'activationDate.date'">
                    {{ props.row.activationDate.date | formatDateModalNoTimeZone }}
                  </span>
                  <span v-else-if="props.column.field === 'accountType'">
                    {{ (props.row.accountType === 'casemgr') ? 'CaseMGR' : 'Refferal' }}
                  </span>
                  <span v-else-if="props.column.field === 'parentAccount'">
                    <router-link v-if="props.row.accountType =='child'" :to="{name:'Manage Account Edit CaseMGR', params: { casemgrid: props.row.parentAccount.id }}" tag="a">{{props.row.parentAccount.organizationName}}</router-link>
                    <router-link v-else-if="props.row.accountType =='parent'" :to="{name:'Manage Account Edit CaseMGR', params: { casemgrid: props.row.id }, hash: '#linked-accounts'}" tag="a">View Hierarchy</router-link>
                    <span v-else>Default</span>
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
              </vue-good-table>
              <div class="not-found-results" v-else>
                <h4>Sorry, no search results were found.</h4>
              </div>
            </div>
          </form>
          <div class="clearfix"></div>
          <div style="margin-top:20px">
            <router-link :to="{name:'Manage Account Add CaseMGR', params: { casemgrid: null }}" tag="button" class="btn green">
              Create CaseMGR Account
            </router-link>
            <router-link :to="{name:'Manage Account Add Referral'}" tag="button" class="btn green" v-if="false">
              Create Referral Account
            </router-link>
            <button class="btn default ladda-button js-export-btn" data-style="expand-left" @click="handleExportBtn">
              <span class="ladda-label">Export</span>
            </button>
            <button class="btn default pull-right ladda-button js-export-user-list-btn" data-style="expand-left" @click="handleExportUserListBtn()">
              <span class="ladda-label">Export List of Users</span>
            </button>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    data() {
      return {
        haveResults: false,
        search: '',
        columns: [
          {
            label: 'Account Name',
            field: 'organizationName',
            filterOptions: {enabled: true}
          },
          {
            label: 'System ID',
            field: 'systemId',
            filterOptions: {enabled: true}
          },
          {
            label: 'Parent Account',
            field: 'parentAccount',
            filterOptions: {enabled: true}
          },
          {
            label: 'Account Owner',
            field: 'accountOwner',
            filterOptions: {enabled: true}
          },
          {
            label: 'Project Contact',
            field: 'projectContact',
            filterOptions: {enabled: true}
          },
          {
            label: 'Activation Date',
            field: 'activationDate.date',
            filterOptions: {enabled: false}
          },
          {
            label: 'Status',
            field: 'status',
            filterOptions: {enabled: true}
          },
          {
            label: 'SMS Status',
            field: 'twilioStatus',
            filterOptions: {enabled: true}
          },
          {
            label: 'Twilio Phone Number',
            field: 'twilioPhone',
            filterOptions: {
              enabled: true
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters([
        'accountsList',
        'getUser'
      ])
    },
    methods: {
      ...mapActions({
        getAccounts: 'GET_ACCOUNTS_ACTION',
        searchAccounts: 'SEARCH_ACCOUNTS_ACTION',
        downloadAccountReport: 'ACCOUNT_LIST_REPORT_ACTION',
        downloadUsersReport: 'ACCOUNT_USERS_LIST_REPORT_ACTION'
      }),
      searchButton() {
        let context = Ladda.create(document.querySelector('.search-ad-submit'));
        this.searchAccounts({q: this.search, context});
      },
      handleExportBtn(){
        const loader = Ladda.create(document.querySelector('.js-export-btn'));
        loader.start();
        this.downloadAccountReport({search: this.search, timezone: this.getUser.time_zone}).then( _res => {
          loader.stop()
        })
      },
      handleExportUserListBtn(){
        const loader = Ladda.create(document.querySelector('.js-export-user-list-btn'));
        loader.start()
        this.downloadUsersReport({search: this.search, timezone: this.getUser.time_zone}).then( _res => {
          loader.stop()
        })
      }
    },
    mounted() {
      this.getAccounts();
    },
    watch: {
      accountsList: () => {
        $('.filter-th').find('input').attr('autocomplete',Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AccountDirectory.vue?3569ae0c